import React from 'react'
import { useTranslation } from 'react-i18next';

function Wishlist() {
  const { t } = useTranslation();

  return (
<div><main className="page-content">
    <div className="tm-section wishlist-area bg-white tm-padding-section wishlist-section-ones">
      <div className="container">
        <div className="tm-wishlist-1">
          <div className="my-wishlist">
            <h4>{t("W1")}<span> {t("W2")}</span></h4>
          </div>
          <div className="wishlist-menbox">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-6">
                <div className="wishlist-one">
                  <button className="tm-wishlist-removeproduct remove-btn remove-btn-two"><i className="ion-close" /></button>
                  <img src="assets/images/brandlogo-wlist.png" />
                  <div className="wishlist-texts">
                    <h2>{t("C3")}</h2>
                    <div className="itemdetails-itemPricing">
                      <span className="itemdetails-boldFont">{t("W3")}</span>
                      <span className="itemdetails-strike">{t("W5")}</span>
                      <span className="itemdetails-discountPercent">{t("W6")}</span>
                    </div>
                    <a className="moveBag-btn" href="#">{t("W3")}</a>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-6">
                <div className="wishlist-one">
                  <button className="tm-wishlist-removeproduct remove-btn remove-btn-two"><i className="ion-close" /></button>
                  <img src="assets/images/brandlogo-wlist1.png" />
                  <div className="wishlist-texts">
                    <h2>{t("C3")}</h2>
                    <div className="itemdetails-itemPricing">
                    <span className="itemdetails-boldFont">{t("W3")}</span>
                      <span className="itemdetails-strike">{t("W5")}</span>
                      <span className="itemdetails-discountPercent">{t("W6")}</span>
                    </div>
                    <a className="moveBag-btn" href="#">{t("W3")}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main></div>

  )
}

export default Wishlist